<script setup lang="ts">
const { defaultCheckoutConfig: checkoutConfig } = useCountryInfo()
/*
  <p v-if="checkoutConfig.showCouponCode" class="mt-4 bg-accent content-accent p-4 rounded-md">
    {{ checkoutConfig.couponMessage }}
    <a class="font-bold" :href="checkoutConfig.checkoutUrl" target="_blank">{{ checkoutConfig.couponCode }}</a>
    {{ checkoutConfig.couponExpiration }}
  </p>
*/
</script>
<template>
  <a
    v-if="checkoutConfig.showCouponCode"
    class="block items-center gap-2 p-4 rounded-md mt-4 bg-accent content-accent brightness-90 hover:brightness-100"
    :href="checkoutConfig.checkoutUrl"
    :title="checkoutConfig.checkoutVendor"
    target="_blank"
  >
    {{ checkoutConfig.couponMessage }} <b>{{ checkoutConfig.couponCode }}</b>
    {{ checkoutConfig.couponExpiration }}
  </a>
</template>
